import { Component, OnInit, OnDestroy, Input, HostListener } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
} from '@angular/router';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';

import { Subscription } from 'rxjs';
import { LeaveSessionDialogComponent } from '@app-shared/components/live-class-dialog/leave-session-dialog/leave-session-dialog.component';
import { FeedbackDialogComponent } from '@app-shared/components/live-class-dialog/feedback-dialog/feedback-dialog.component';
import { SessionDetailsDialogComponent } from '@app-shared/components/live-class-dialog/session-details-dialog/session-details-dialog.component';
import { ClassModel } from 'src/app/model/class';
import { ReportIssueDialogComponent } from '@app-shared/components/live-class-dialog/report-issue-dialog/report-issue-dialog.component';
import { UserService } from '@app-services/user/user.service';
import { ClassService } from 'src/app/core/services/class.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { TaskTimer } from 'tasktimer';
import { isUserAdmin } from '@app-helpers/functions';
import { environment } from '@app-environments/environment';
import { ReferralDialogComponent } from '@app-shared/components/referral-dialog/referral-dialog.component';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';

// Request a wake lock 
export const requestWakeLock = () => {  
  const navigatorWithWakeLock = navigator as Navigator & { wakeLock: any };
  if ('wakeLock' in navigatorWithWakeLock) { 
    const wakeLock: any = navigatorWithWakeLock?.wakeLock;
    wakeLock?.request('screen') 
      .then((wakeLock: any) => { 
        console.log('Wake lock activated'); 
      })
      .catch((err: any) => { 
        console.error('Could not activate wake lock:', err); 
      });
  } else {
    console.warn('Wake Lock API not supported'); 
  }
} 
// Release the wake lock (may not be supported by all browsers) 
export const releaseWakeLock = () => {
  const navigatorWithWakeLock = navigator as Navigator & { wakeLock: any };
  if ('wakeLock' in navigatorWithWakeLock) {
    const wakeLock: any = navigatorWithWakeLock?.wakeLock;
    if('release' in wakeLock){
      wakeLock?.release()
      .then(() => {
        console.log('Wake lock released');
      })
      .catch((err: any) => { 
        console.error('Could not release wake lock:', err); 
      });
    }
  }
} 

@Component({
  selector: 'app-live-class-header',
  templateUrl: './live-class-header.component.html',
  styleUrls: [
    './live-class-header.component.css',
    '../../../../../assets/css/live-portal-styles.css',
  ],
})
export class LiveClassHeaderComponent implements OnInit, OnDestroy {
  interval: any;
  time: number = 0;
  timeOver: boolean = false;
  display: any;
  @Input() isRecordingClass: boolean = false;

  public subscription: Subscription[] = [];

  public liveClassDetails: any = null;

  public crntUserDetails: any = null;

  public isSessionEnd: boolean = false;

  public isEnabledLeaveSession: boolean = false;

  public isDisabledLiveClassMenus: boolean = true;

  public isShownRightMenu: boolean = true;

  public userTypeId: number = 1;

  public mob_hdr_btn_action_status: boolean = false;
  public isLandScape: boolean = false;
  public isStudentLiveClassPage: boolean = false;
  public enableLcUIChanges = environment?.enableLcUIChanges;
  constructor(
    public router: Router,
    private dialog: MatDialog,
    private userService: UserService,
    private classService: ClassService,
    private _eventHandlingService: EventHandlingService,
    private _inviteNdEarn:InviteEarnService,
  ) {
    this.subscription.push(
      this._eventHandlingService.liveClassData$.subscribe((res: any) => {
        if (res && res.dataFor == 'classData') {
          this.liveClassDetails = new ClassModel(res.data);
          let result: any;
          result = UtilityService.getTime(
            this.liveClassDetails.schedule.endTime,
            res.data.utcTime,
            this.liveClassDetails.schedule.startTime
          );

          this.time = Number(result.time);
          const timer = new TaskTimer(result.start);
          timer.add({id: 'startTimer',totalRuns: 1, callback(task) {
            if (!this.display) {
              this.startTimer();
            } 
          }}).start();
        }
      })
    );

    this.subscription.push(
      this._eventHandlingService.liveClassAction$.subscribe((res: any) => {
        if (res && res.event == 'enabledLeaveSession') {
          this.enabledLeaveSession();
        }
      })
    );
  }

  ngOnInit(): void {
    this.checkCurrentRoute();
    this.isMobileLandScape();
    this.isStudentLiveClassPage = this.router.url.includes('student-live-class');
    this.subscription.push(
      this.router.events.subscribe((event) => {
        if (
          event instanceof NavigationCancel ||
          event instanceof NavigationError ||
          event instanceof NavigationEnd
        ) {
          this.checkCurrentRoute();
        }
      })
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileLandScape();
  };

  isMobileLandScape() {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    if (windowWidth < 961 && windowHeight <= windowWidth) {
      this.isLandScape = true;
    } else {
      this.isLandScape = false;
    }
    if(windowWidth < 961 && this.isStudentLiveClassPage) {
      requestWakeLock();
    }
  }

  checkCurrentRoute = () => {
    this.userTypeId = this.userService.getUserType();
    this.crntUserDetails = this.userService.getMobileAndName();
    this.isStudentLiveClassPage = this.router.url.includes('student-live-class');
    if (
      this.router.url.includes('join-class') ||
      this.router.url.includes('waiting-class')
    ) {
      this.isDisabledLiveClassMenus = true;
    } else {
      if (this.router.url.includes('end-class')) {
        this.isSessionEnd = true;
      } else {
        this.isDisabledLiveClassMenus = false;
      }
    }
    if (this.router.url.includes('rewatch')) {
      this.isShownRightMenu = false;
    } else {
      this.isShownRightMenu = true;
    }
  };

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.forEach((v) => v.unsubscribe());
    }
    releaseWakeLock();
    this.clearTimer();
  }

  enabledLeaveSession = () => {
    this.isEnabledLeaveSession = true;
  };

  leaveSession = () => {
    const config: MatDialogConfig = {
      data: {},
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
    };
    const dialogRef = this.dialog.open(LeaveSessionDialogComponent, config);
    dialogRef.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
      if (res.event == 'stopLearning') {
        if (this.userTypeId == 1) {
          this._eventHandlingService.liveClassAction({ event: 'killZoom' });
          this.sendResForLeaveClass();
          this.showFeedbackForm();
        } else {
          this._eventHandlingService.liveClassAction({
            event: 'leaveZoomSession',
          });
        }
      } else {
        this._eventHandlingService.liveClassAction({
          event: 'resumeZoomSession',
        });
      }
    });
  };

  sendResForLeaveClass = () => {
    // this.classService
    //   .studentJoinLeftSession({
    //     userId: this.crntUserDetails.userId,
    //     classId: this.liveClassDetails.id,
    //     status: 'left'
    //   })
    //   .subscribe((res) => {
    //     console.log('onUserLeave', res);
    //   });
      let getSpenttTime = JSON.parse(localStorage.getItem('class-time-spent'));
      if (getSpenttTime && (getSpenttTime / 60) >= 5) {
        isUserAdmin(this.userService).then((bool) => {
          if(!bool) {this.userService.saveRewardHistory(12).subscribe(res => localStorage.removeItem('class-time-spent'));};
        })
      }
  };

  showFeedbackForm = () => {
    const config: MatDialogConfig = {
      data: {
        eclassInfo: this.liveClassDetails,
        crntUserInfo: this.crntUserDetails,
      },
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
    };
    const feedbackDialog = this.dialog.open(FeedbackDialogComponent, config);
    feedbackDialog.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    feedbackDialog.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
      if(res?._formValues?.questions?.[0]?.options?.[3]?.selected && res?._formValues?.questions?.[1]?.options?.[0]?.selected){
        this._inviteNdEarn?.userReferralRemider(this.crntUserDetails?.userId,{})?.subscribe((res:any)=>{
          if(res?.showReminder){
            this._inviteNdEarn?.invokeReferralDialog(this.dialog,this.crntUserDetails?.userId,'FromFeedback',this._eventHandlingService)
          }else{
            this._eventHandlingService?.liveClassAction({ event: 'leaveZoomSession' });
          }
        })
      }else{
      this._eventHandlingService?.liveClassAction({ event: 'leaveZoomSession' });
      }
      // this._eventHandlingService.liveClassAction({ event: 'leaveZoomSession' });
    });
  };

  showSessionInfo = () => {
    const config: MatDialogConfig = {
      data: this.liveClassDetails,
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
    };
    const sessionInfoDialog = this.dialog.open(
      SessionDetailsDialogComponent,
      config
    );
    sessionInfoDialog.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    sessionInfoDialog.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    });
  };

  reportAnIssue = () => {
    const config: MatDialogConfig = {
      data: {
        eclassInfo: this.liveClassDetails,
        crntUserInfo: this.crntUserDetails,
      },
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: 'mat-dialog-pr-none',
    };
    const reportAnIssueDialog = this.dialog.open(
      ReportIssueDialogComponent,
      config
    );
    reportAnIssueDialog.afterOpened().subscribe(() => {
      document.body.classList.add('modal-open');
    });

    reportAnIssueDialog.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
      console.log('Report An Issue: ', res);
    });
  };

  sessionNotes = () => {};

  clearTimer() {
    if (this.interval) {
      this.interval.stop();
    }
  }

  startCollapsedTimer() {
    this.clearTimer();
    const tenMinuteInSeconds = 60 * 10;
    this.time = UtilityService.getTimePassed(
      this.liveClassDetails.schedule.endTime,
      this.liveClassDetails.schedule.serverTime
    );

    if (this.time <= tenMinuteInSeconds) {
      this.interval = new TaskTimer(1000);
      this.interval.add(task => {
        this.time++;
        this.display = this.transform(this.time);
        if (this.time >= tenMinuteInSeconds) {
          this.clearTimer();
        }
      }).start(); 
    }
  }

  startTimer() {
    this.clearTimer();
    this.interval = new TaskTimer(1000);
    this.interval.add(task => {
      this.display = this.transform(this.time);

      if (this.time) {
        this.time--;
      } else {
        this.timeOver = true;
        this.startCollapsedTimer();
      }
    }).start(); 
  }

  perfectNumber(n) {
    return n > 9 ? '' + n : '0' + n;
  }

  transform(value: number): string {
    var sec_num = value;
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    let timeValue: any;
    if (hours > 0) {
      timeValue =
        hours +
        ':' +
        this.perfectNumber(minutes) +
        ':' +
        this.perfectNumber(seconds);
    } else {
      timeValue =
        this.perfectNumber(minutes) + ':' + this.perfectNumber(seconds);
    }
    return timeValue;
  }


  mob_hdr_btn_action(){
    console.log(this.mob_hdr_btn_action_status);
    this.mob_hdr_btn_action_status =! this.mob_hdr_btn_action_status;
  }

  logoClicked() {
    this.sendResForLeaveClass();
    if (this.router.url.includes('rewatch')) {
      this.classService.rewatchLogoClicked.next(true);
    }
    this.router.navigate(['/dashboard/liveclass']);
  }
}
